// extracted by mini-css-extract-plugin
module.exports = {"root":"_2j1rF","grid":"_1wYnq","bold":"_3ZdH2","emptyAttribute":"_1bjPQ"};